module.exports = __webpack_public_path__ + "img/faq.699c7a8e.svg";